import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms'
import { LabelsKeys } from './LabelsKeys'
import { ImportAvisConfirmationModalComponent } from '../import-avis-confirmation-modal/import-avis-confirmation-modal.component'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImportAvisService } from '../services/import-avis.service';
import { BoampAvisWrapper } from '../models/BoampAvisWrapper';
import { BoampAvis } from '../models/BoampAvis';
import { Router } from '@angular/router';
import { SessionService } from '../../administration/services/session.service';
import { User } from '../../administration/models/user';
import { CanNavigateInStepperService } from '../../shared/services/can-navigate-in-stepper.service';
@Component({
	selector: 'app-import',
	templateUrl: './import.component.html',
	styleUrls: ['./import.component.scss']
})
export class ImportComponent implements OnInit {

	public form: any;
	public labelsKeys: LabelsKeys = new LabelsKeys();
	private boampAvis: BoampAvis;


	constructor(private modalService: NgbModal, private importAvisService: ImportAvisService,
		private router: Router, private session: SessionService,
		private canNavigateInStepperService: CanNavigateInStepperService
	) {
	}

	ngOnInit(): void {
		this.form = new FormGroup({
			idWeb: new FormControl(''),
			codeAcheteur: new FormControl(''),
			checkImport: new FormControl({})
		});
	}

	send(): void {
		let user: User = this.session.getUser();
		let numPublication = this.form.controls['idWeb'].value;
		let loginAnnouceur = this.form.controls['codeAcheteur'].value;
		if (this.isEmptyOrNullOrUndefined(numPublication) && this.isEmptyOrNullOrUndefined(loginAnnouceur)) {
			this.form.controls['idWeb'].setErrors({ required: true });
			this.form.controls['codeAcheteur'].setErrors({ required: true });
			this.form.controls['checkImport'].value = {};
		} else {
		this.importAvisService.searchBoampAvis(numPublication, user.siret, user.service, loginAnnouceur)
			.subscribe(res => {
				if (res) {
					if (res.status == "KO") {
						if (res.erreurs && res.erreurs.length != 0) {
							res.erreurs.forEach(erreur => {
								switch (erreur) {
									case "notExist":
										this.form.addControl('checkImport', new FormControl({}));
										this.form.controls['checkImport'].value = { rgCtrls: 'notExist', ctrlValidation: true, validation_message: 'avis.import.error.notExist' };
										this.form.controls['idWeb'].setErrors({ notExist: erreur });
										break;
									case "notValid":
										this.form.addControl('checkImport', new FormControl({}));
										this.form.controls['checkImport'].value = { rgCtrls: 'notValid', ctrlValidation: true, validation_message: 'avis.import.error.notValid' };
										this.form.controls['codeAcheteur'].setErrors({ notValid: erreur });
										break;
									case "notAuthorised":
										this.form.addControl('checkImport', new FormControl({}));
										this.form.controls['checkImport'].value = { rgCtrls: 'notAuthorised', ctrlValidation: true, validation_message: 'avis.import.error.notAuthorised' };
										this.form.controls['codeAcheteur'].setErrors({ notAuthorised: erreur });
										break;
									case "avisExist":
										this.form.addControl('checkImport', new FormControl({}));
										this.form.controls['checkImport'].value = { rgCtrls: 'avisExist', ctrlValidation: true, validation_message: 'avis.import.error.avisExist' };
										this.form.controls['idWeb'].setErrors({ avisExist: erreur });
										break;
									case "avisPasEncorePublie":
										this.form.addControl('checkImport', new FormControl({}));
										this.form.controls['checkImport'].value = { rgCtrls: 'avisPasEncorePublie', ctrlValidation: true, validation_message: 'avis.import.error.avisPasEncorePublie' };
										this.form.controls['idWeb'].setErrors({ avisPasEncorePublie: erreur });
										break;
									case "avisNonImporte":
										this.form.addControl('checkImport', new FormControl({}));
										this.form.controls['checkImport'].value = { rgCtrls: 'avisNonImporte', ctrlValidation: true, validation_message: 'avis.import.error.avisNonImporte' };
										this.form.controls['idWeb'].setErrors({ avisNonImporte: erreur });
										break;
									case "idWebRequired":
										this.form.addControl('checkImport', new FormControl({}));
										this.form.controls['checkImport'].value = { rgCtrls: 'idWebRequired', ctrlValidation: true, validation_message: 'avis.import.error.idWebRequired' };
										this.form.controls['idWeb'].setErrors({ idWebRequired: erreur });
										break;
									case "identifiantRequired":
										this.form.addControl('checkImport', new FormControl({}));
										this.form.controls['checkImport'].value = { rgCtrls: 'identifiantRequired', ctrlValidation: true, validation_message: 'avis.import.error.identifiantRequired' };
										this.form.controls['codeAcheteur'].setErrors({ identifiantRequired: erreur });
										break;
								}

							})

						}
					}
					if (res.status == "OK") {
						let wrapper: BoampAvisWrapper = res;
						this.boampAvis = wrapper.results[0];
						const modalRef = this.modalService.open(ImportAvisConfirmationModalComponent);
						modalRef.componentInstance.boampAvis = this.boampAvis;
						modalRef.componentInstance.refConsultation = this.canNavigateInStepperService.reference || sessionStorage.getItem('referenceConsultation');
						modalRef.result.then(res => {
							if (res) {
								const refConsultation = this.canNavigateInStepperService.reference || sessionStorage.getItem('referenceConsultation');
								// Utiliser la nouvelle méthode qui enchaîne : import -> enrichissement inputIds -> sauvegarde
								this.importAvisService.importAndEnrich(numPublication, user, loginAnnouceur, refConsultation)
									.subscribe({
										next: (savedAvis) => {
											if (savedAvis) {
												this.router.navigate(['/avisdepublicite/listerAvisPub']);
											}
										},
										error: (error) => {
											console.error('Erreur lors de l\'import et enrichissement:', error);
											// En cas d'erreur, on utilise l'ancienne méthode comme fallback
											this.importAvisService.import(numPublication, user, loginAnnouceur)
												.subscribe(res => {
													if (res) {
														this.router.navigate(['/avisdepublicite/listerAvisPub']);
													}
												});
										}

									});
							}
						})
						 .catch(res => {
                          console.log('Modal dismissed:', res);
                        });
					}
				}
			});
		}
	}

	isEmptyOrNullOrUndefined(value): boolean{
		return (value === undefined || value === null || value === '');
	}

}
